(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-featured-product')) {
    customElements.define('pp-featured-product', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const thumbnail = event.target.closest('[data-show-image]');
          if (thumbnail && this.contains(thumbnail)) this.showImage(thumbnail.dataset.showImage);
        };
        this.onChange = (event) => {
          if (event.target.matches('[data-variant-select]')) this.updateVariant(event.target.selectedOptions[0]);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        const buttonLabel = this.querySelector('.product-form__submit > span');
        this.addLabel = this.querySelector('[data-add-label]')?.dataset.addLabel || window.variantStrings?.addToCart || buttonLabel?.textContent.trim();
        if (buttonLabel && !buttonLabel.closest('button').disabled) buttonLabel.textContent = this.addLabel;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }
      showImage(id) {
        if (!id || !Array.from(this.querySelectorAll('[data-image-id]')).some(slide => slide.dataset.imageId === id)) return;
        this.querySelectorAll('[data-image-id]').forEach(slide => { slide.hidden = slide.dataset.imageId !== id; });
        this.querySelectorAll('[data-show-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showImage === id)));
      }
      updateVariant(option) {
        const form = this.querySelector('product-form');
        if (!form || !option) return;
        const input = form.querySelector('[name="id"]');
        input.value = option.value;
        input.dispatchEvent(new Event('change', { bubbles:true }));
        const available = option.dataset.available === 'true';
        const button = form.querySelector('[type="submit"]');
        button.disabled = !available;
        button.removeAttribute('aria-disabled');
        button.querySelector('span').textContent = available ? this.addLabel : (window.variantStrings?.soldOut || option.textContent);
        form.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', '');
        this.querySelectorAll('[data-current-price]').forEach(price => { price.textContent = option.dataset.price; });
        this.querySelectorAll('[data-compare-price]').forEach(price => { price.hidden = !option.dataset.compare; });
        this.querySelectorAll('[data-compare-value]').forEach(price => { price.textContent = option.dataset.compare; });
        this.querySelectorAll('[data-unit-price]').forEach(price => { price.hidden = !option.dataset.unit; price.textContent = option.dataset.unit; });
        const quantity = this.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        this.querySelectorAll('[data-product-link]').forEach(link => {
          const url = new URL(link.href); url.searchParams.set('variant',option.value); link.href = url;
        });
        this.showImage(option.dataset.image);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
